import { logGreyError } from "owa-analytics";
import { getItem, removeItem, setItem } from "owa-local-storage";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

import type { PlacesSettings } from "../types/PlacesSettings";

export const PLACES_SETTINGS_STORAGE_KEY = "places_placesSettings";
export const PLACES_SETTINGS_TTL_IN_DAYS = 30;

export type PlacesSettingsCache = {
    [accountKey in string]?: PlacesSettingsCacheEntry;
};

export interface PlacesSettingsCacheEntry {
    accountKey: string;
    timestamp: number;
    placesSettings: PlacesSettings;
}

export function getPlacesSettingsCache(): PlacesSettingsCache | undefined {
    try {
        const cache = getItem(self, PLACES_SETTINGS_STORAGE_KEY);
        return typeof cache === "string" ? (JSON.parse(cache) as PlacesSettingsCache) : undefined;
    }
    catch (err) {
        logGreyError("GetPlacesSettingsCacheError", getModuleContextMailboxInfo(), err as Error);
        return undefined;
    }
}

export function setPlacesSettingsCache(cache: PlacesSettingsCache): void {
    try {
        setItem(self, PLACES_SETTINGS_STORAGE_KEY, JSON.stringify(cache));
    }
    catch (err) {
        logGreyError("SetPlacesSettingsCacheError", getModuleContextMailboxInfo(), err as Error);
    }
}

export function deletePlacesSettingsCache(): void {
    removeItem(self, PLACES_SETTINGS_STORAGE_KEY);
}
